import { render, staticRenderFns } from "./ReadyToBe.vue?vue&type=template&id=c07ca9fc&scoped=true&"
import script from "./ReadyToBe.vue?vue&type=script&lang=js&"
export * from "./ReadyToBe.vue?vue&type=script&lang=js&"
import style0 from "./ReadyToBe.vue?vue&type=style&index=0&id=c07ca9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07ca9fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
